import React, {useEffect, useState} from 'react';
import { ListItem, ListItemButton, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, CircularProgress } from '@mui/material';
import { Button } from '@mui/material';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { generateGuestToken } from '../../../api/authService';
import { useTranslation } from 'react-i18next';

export default function QrCode() {

    const { t } = useTranslation('common');

    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
    };

    const [qrUrl, setQrUrl] = useState(null);

    useEffect(() => {
        setQrUrl(null);
        if (open) {
            const fetchTokenUrl = async () => {
                const response = await generateGuestToken();
                const baseUrl = window.location.origin;
                const url =  `${baseUrl}/login-guest?token=${response.token}`;
                const qUrl = `https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=${url}`;
                setQrUrl(qUrl);
            };
            fetchTokenUrl();
        }
      }, [open]);

    return (
        <>
        <ListItem>
            <ListItemButton onClick={handleClickOpen}>
            <ListItemIcon>
                <QrCode2Icon fontSize='large' color='secondary' />
            </ListItemIcon>
            <ListItemText 
                primary="QR Code"
                secondary="generate QR code for new patients"
            />
            </ListItemButton>
        </ListItem>

        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogTitle>
                <Stack alignItems="center">
                    New Patient QR Code
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2} alignItems="center">
                <Box display="flex" alignItems="center"  justifyContent="center" sx={{ width: 240, height: 240 }}>
                    {!qrUrl ? 
                    <CircularProgress /> 
                    :
                    <img src={qrUrl} alt="QR Code" />
                    } 
                </Box>
                <Typography variant="body1">
                    {t('pet_owners.messages.scan_qr_code')}
                </Typography>
                <Typography variant="body2">
                    {t('pet_owners.messages.qr_code_expire')}
                </Typography>
                </Stack>
            </DialogContent>
            <DialogActions>
                <div style={{flex: '1 0 0'}} />
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        </>
    );
}